var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNfc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_45316_7382",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91114 0.354664C1.12615 0.395583 0.596026 0.968446 0.562043 1.70839C0.528061 2.43811 0.514468 16.0402 0.562043 16.7802C0.609619 17.5133 1.17032 18.0691 1.91114 18.1134C2.73011 18.1612 5.38751 18.168 6.15211 18.168C4.78603 17.2234 4.59913 15.4435 4.47339 12.1393C4.39863 10.182 4.4666 3.31787 4.47339 3.02803L4.50737 1.15599L11.681 8.35429V10.6082L5.9788 4.88301C5.96521 6.0151 5.94822 7.49159 5.94822 8.84191C5.94822 10.1581 5.96861 11.3482 6.00599 11.9756C6.22008 15.5765 6.5565 17.2644 8.42892 17.9293C9.00322 18.1305 9.53674 18.1782 10.4271 18.1919C11.1611 18.2021 16.289 18.1953 17.0298 18.1578C17.8148 18.1168 18.3449 17.544 18.3789 16.804C18.4163 16.0743 18.4265 2.50631 18.3789 1.76636C18.3313 1.03323 17.7706 0.47742 17.0298 0.433092C16.2074 0.381943 13.5534 0.341024 12.7888 0.341024C14.1549 1.28557 14.3418 3.06554 14.4676 6.36973C14.5423 8.32701 14.4743 15.1911 14.4676 15.481L14.4336 17.353L7.25993 10.1547V7.90419L12.9655 13.626C12.9791 12.4939 12.9961 11.0174 12.9961 9.66711C12.9961 8.35088 12.9757 7.16083 12.9384 6.53341C12.7243 2.93255 12.3912 1.24465 10.5154 0.583127C9.94113 0.381943 9.4076 0.330795 8.51727 0.320565C8.30998 0.317155 7.75607 0.317155 7.05264 0.317155C5.24479 0.313745 2.44466 0.323975 1.91114 0.354664Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_45316_7382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4223 0.313721H0.513672V18.2021H18.4223V0.313721Z",
    fill: "url(#paint0_linear_45316_7382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45316_7382",
    x1: 9.46918,
    y1: 24.347,
    x2: 9.46918,
    y2: 0.512554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1269,
    stopColor: "#9BD7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3353,
    stopColor: "#59BBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#29A6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6437,
    stopColor: "#0B9ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7191,
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfc);
export default __webpack_public_path__ + "static/media/nfc.a6ba2e1d5cff063ec1b04f4b21d7e2b7.svg";
export { ForwardRef as ReactComponent };